import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { ViewPage as Component } from './ViewPage';
import { PageNotFoundEmptyState } from '../empty-state';
import { I18nProvider } from '../i18n/I18nProvider';
import fetchTranslations from '../i18n/fetchTranslations';
// Do not place formatMessage / FormattedMessage / useIntl calls here outside of the I18nProvider.
// They will not function correctly due to a lack of I18n context.

export var ViewPage = function ViewPage(props) {
  return /*#__PURE__*/React.createElement(I18nProvider, {
    locale: props.locale,
    fetchTranslations: fetchTranslations
  }, /*#__PURE__*/React.createElement(ErrorBoundary, {
    fallback: /*#__PURE__*/React.createElement(PageNotFoundEmptyState, null)
  }, /*#__PURE__*/React.createElement(Component, props)));
};